import React, { useState } from "react";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import FileCommentsBtn from "./FileCommentsBtn";
import { Button } from "primereact/button";
import FileStatusSummaryReport from "./FileStatusSummaryReport";

const FileStatusSummaryDetail = ({ data }) => {
  const [fileHeadId, setfileHeadId] = useState(null);
  const [fileStatusData, setFileStatusData] = useState([null]);
  const [rows, setRows] = useState(20);
  const [first, setFirst] = useState(0);

  const handlePageChange = (event) => {
    setFirst(event.first);
    setRows(event.rows);
  };

  const actionTemplate = (rowData) => {
    if (rowData?.fileStatusCode === "I") {
      return (
        <div style={{ display: "flex", justifyContent: "flex-start" }}>
          <FileCommentsBtn fileHeadId={data?.fileHeadId} />
        </div>
      );
    }
    return (
      <div style={{ display: "flex", justifyContent: "flex-start" }}>
        <FileCommentsBtn fileHeadId={rowData?.fileHeadId} />
        <Button
          icon="pi pi-eye"
          onClick={() => handleButtonClick(rowData)}
          className="p-button-rounded p-button-info p-mr-2"
        />
      </div>
    );
  };

  const handleButtonClick = (rowData) => {
    setfileHeadId(rowData?.fileHeadId);
    setFileStatusData(rowData);
  };

  const exportExcel = () => {
    import("xlsx").then((xlsx) => {
      // Define the columns to export and their new names
      const columnMapping = {
        batchId: "Batch Id",
        productName: "Product Name",
        fileName: "File Name",
        fileStatusDescr: "Status Description",
        fileUploadDate: "Uploaded Date",
        fileUploadBy: "Uploaded By",
        processedRecords: "Processed Records",
        errorRecords: "Error Records",
        pendingRecords: "Pending Records",
        totalRecords: "Total Records",
        disbursedAmount: "Disbursed Amount",
        balanceBefore: "Balance Before",
        balanceAfter: "Balance After",
        transSuccessRecords: "Transaction Success Records",
      };

      // Map the data to include only the specified columns with new names
      const exportData = data.map((item) => {
        let obj = {};
        Object.keys(columnMapping).forEach((key) => {
          obj[columnMapping[key]] = item[key];
        });
        return obj;
      });

      // Convert the mapped data to a worksheet
      const worksheet = xlsx.utils.json_to_sheet(exportData && exportData);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });

      // Save the Excel file
      saveAsExcelFile(excelBuffer, "File Status Summary");
    });
  };

  const saveAsExcelFile = (buffer, fileName) => {
    import("file-saver").then((FileSaver) => {
      let EXCEL_TYPE =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      let EXCEL_EXTENSION = ".xlsx";
      const data = new Blob([buffer], {
        type: EXCEL_TYPE,
      });
      FileSaver.saveAs(data, fileName + EXCEL_EXTENSION);
    });
  };

  // const exportExcel = () => {
  //   import('xlsx').then(xlsx => {
  //     const worksheet = xlsx.utils.json_to_sheet(data && data);
  //     const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
  //     const excelBuffer = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
  //     saveAsExcelFile(excelBuffer, 'File Status Summary');
  //   });
  // }

  // const saveAsExcelFile = (buffer, fileName) => {
  //   import('file-saver').then(FileSaver => {
  //     let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  //     let EXCEL_EXTENSION = '.xlsx';
  //     const data = new Blob([buffer], {
  //       type: EXCEL_TYPE
  //     });
  //     FileSaver.saveAs(data, fileName + EXCEL_EXTENSION);
  //   });
  // }

  const header = (
    <div
      className="flex justify-content-center"
      style={{ display: "flex", justifyContent: "space-between" }}
    >
      <p>File Status Summary</p>
      <Button
        label="Export Excel"
        type="button"
        icon="pi pi-file-excel"
        onClick={exportExcel}
        className="p-button-success p-mr-2"
        data-pr-tooltip="XLS"
      />
    </div>
  );

  return (
    <>
      <div className="card p-datatable-sm">
        {data && (
          <DataTable
            header={header}
            value={data && data}
            dataKey="fileDetailId"
            paginator
            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
            rows={rows}
            first={first}
            rowsPerPageOptions={[10, 20, 50, 100, 200]}
            onPage={handlePageChange}
            emptyMessage="No data found."
            autoLayout
          >
            <Column filter field="batchId" header="Batch Id" />
            <Column filter field="productName" header="Product Name" />
            <Column filter field="fileName" header="File Name" />
            {/* <Column filter field="fileStatusCode" header="File Status Code" /> */}
            <Column filter field="fileStatusDescr" header="Status Desc" />
            <Column filter field="fileUploadDate" header="Upload Date" />
            <Column filter field="fileUploadBy" header="Upload By" />
            <Column
              filter
              field="processedRecords"
              header="Processed Records"
            />
            <Column filter field="errorRecords" header="Error Records" />
            <Column filter field="pendingRecords" header="Pending Records" />
            <Column filter field="totalRecords" header="Total Records" />
            <Column filter field="disbursedAmount" header="Disbursed Amount" />
            <Column filter field="balanceBefore" header="Balance Before" />
            <Column filter field="balanceAfter" header="Balance After" />
            <Column
              filter
              field="transSuccessRecords"
              header="Transaction Success Records"
            />
            {/* <Column filter field="mcStatus" header="Mc Status" /> */}
            <Column filter body={actionTemplate} header="Action" />
          </DataTable>
        )}
      </div>
      <div className="card p-datatable-sm">
        <FileStatusSummaryReport
          fileHeadId={fileHeadId}
          fileStatusData={fileStatusData}
        />
      </div>
    </>
  );
};

export default FileStatusSummaryDetail;
